import React from "react";
import { styled } from '@mui/material/styles';
//import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import {
  Button,
  Card,
  CardContent,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
} from "@mui/material";
//import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { TField, MUITableD, TSelect } from "components";
import { selOptions } from "utilities";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
const PREFIX = 'Detail';

const classes = {
  root: `${PREFIX}-root`,
  fields: `${PREFIX}-fields`,
  input: `${PREFIX}-input`,
  dialogtypo: `${PREFIX}-dialogtypo`
};

const Root = styled('div')((
  {
    theme
  }
) => ({
  [`& .${classes.root}`]: {},
  [`& .${classes.fields}`]: {},

  [`& .${classes.input}`]: {
    display: "none",
  },

  [`& .${classes.dialogtypo}`]: {
    marginBottom: theme.spacing(3),
  }
}));

function Detail({
  data,
  error,
  helper,
  codes,
  handleChange,
  refundPopup,
  handleLeaveRefundPopupCancel,
  handleLeaveRefundPopupSave,
  className,
  ...rest
}) {
  // const[pic, setPic] = useState (data.image);


  const { t } = useTranslation("transaction");
  const navigate = useNavigate();

  let amounttxt = "";
  if (data.amount) {
    amounttxt = " up to $" + data.amount.toFixed(2);
  }

  /* const changeImg = (base64) => {
    const target = {name: "image", value: base64};
    const persist = () => { }
    const event = {target: target, persist: persist };
    handleChange(event);
  } */

  /* const handleImgUpload = (event) => {
    if (event.target.files[0]) {
    //  console.log(event.target.files[0]);
    //  console.log(data.image)
      Resizer.imageFileResizer(
        event.target.files[0],
        300,
        300,
        "JPEG",
        10,
        0,
        (uri) => changeImg(uri),
        "base64",
        200,
        200
      );
    }
  } */

  const handleRowClick = () => { };

  const handleRelRowClick = (rowdata) => {
    navigate("/app/transaction/" + rowdata[0]);
  };

  const columns = [
    { name: "lineitem", label: t("Line Item") },
    { name: "sku", label: t("SKU") },
    { name: "qty", label: t("Sold Qty") },
    { name: "freeQty", label: t("Free Qty") },
    { name: "percentdiscount", label: t("% Discount") },
    { name: "price", label: t("Price") },
  ];

  const relColumns = [
    { name: "guid", label: t("GUID"), options: { display: false } },
    { name: "transactionts", label: t("Timestamp") },
    { name: "transactiontype", label: t("Type") },
    {
      name: "amount",
      label: t("Amount"),
      options: { customBodyRender: (value) => value.toFixed(2) },
    },
    { name: "result", label: t("Result Code") },
    { name: "resultmessage", label: t("Result Message") },
    { name: "sorg", label: t("Sales Org") },
    { name: "profitcenter", label: t("Profit Center") },
    { name: "customernr", label: t("Customer") },
    { name: "outlet", label: t("Outlet") },
    { name: "description", label: t("Description") },
  ];

  return (
    <Root>
      <Card>
        <CardContent>
          <form>
            <Grid
              container
              className={clsx(classes.root, className)}
              spacing={3}
              {...rest}
            >
              {/*           <Grid item lg={12} md={12} xl={12} xs={12}>
             {{data.active ? 
              <Chip 
              color='primary' 
              label={t('Active')}
              clickable
              onClick={handleChange}
              name="active"
              value="true"
              /> 
              :
              <Chip 
                color='primary'
                variant='outlined' 
                label={t('Inactive')}
                clickable
                onClick={handleChange}
                name="active"
                value="false"
              />
            }}
            </Grid> */}
              <Grid item lg={4} md={4} xl={4} xs={4}>
                <TField
                  label={t("Transaction ID")}
                  name="transactionid"
                  value={data.transactionid || ""}
                  onChange={handleChange}
                  // opt={selOptions(codes, "mattype")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Timestamp")}
                  name="transactionts"
                  value={data.transactionts || ""}
                  onChange={handleChange}
                  // opt={selOptions(codes, "packtype")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("STAN")}
                  name="transactionnumber"
                  value={
                    data.transactionnumber != null
                      ? data.transactionnumber + ""
                      : ""
                  }
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TSelect
                  label={t("Sales Org")}
                  name="sorg"
                  value={data.sorg || ""}
                  onChange={handleChange}
                  opt={selOptions(codes, "sorg")}
                  ro={false}
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Profit Center")}
                  name="profitcenter"
                  value={data.profitcenter || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Transaction Type")}
                  name="transactiontype"
                  value={data.transactiontype || ""}
                  onChange={handleChange}
                  // opt={selOptions(codes, "matgroup")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Amount")}
                  name="amount"
                  value={data.amount != null ? data.amount.toFixed(2) : ""}
                  onChange={handleChange}
                  // opt={selOptions(codes, "packtype")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Free Amount")}
                  name="freeamount"
                  value={
                    data.freeamount != null ? data.freeamount.toFixed(2) : ""
                  }
                  onChange={handleChange}
                  // opt={selOptions(codes, "packtype")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Result Code")}
                  name="result"
                  value={data.result != null ? data.result + "" : ""}
                  onChange={handleChange}
                  // opt={selOptions(codes, "packtype")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Result Message")}
                  name="resultmessage"
                  value={data.resultmessage || ""}
                  onChange={handleChange}
                  // opt={selOptions(codes, "packtype")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Entry")}
                  name="entry"
                  value={data.entry || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Confirmation ID")}
                  name="confirmationid"
                  value={data.confirmationid || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "salesunit")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Customer")}
                  name="customernr"
                  value={data.customernr || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Outlet")}
                  name="outlet"
                  value={data.outlet || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("GPU Serial Number")}
                  name="serialnr"
                  value={data.serialnr || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Device ID / Mac Address")}
                  name="deviceid"
                  value={data.deviceid || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Cardtype")}
                  name="cardtype"
                  value={data.cardtype || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "product")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Last 4")}
                  name="lastfour"
                  value={data.lastfour || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "product")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Expiration")}
                  name="expiration"
                  value={data.expiration || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "product")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  fullWidth
                  label={t("Entry mode")}
                  name="entry"
                  value={data.entry || ""}
                  onChange={handleChange}
                  // error={error.currency || false}
                  // helperText={helper.currency || ""}
                  ro={false}
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  fullWidth
                  label={t("Currency")}
                  name="currency"
                  value={data.currency || ""}
                  onChange={handleChange}
                  // error={error.currency || false}
                  // helperText={helper.currency || ""}
                  ro={false}
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Invoice Number")}
                  name="invoicenumber"
                  value={data.invoicenumber || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Batch")}
                  name="batch"
                  value={data.batch || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Status")}
                  name="status"
                  value={data.status || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Processing Time")}
                  name="processingtime"
                  value={data.processingtime ? data.processingtime + " ms" : ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Hostname")}
                  name="hostname"
                  value={data.hostname || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={2} md={2} xl={2} xs={2}>
                <TField
                  label={t("Backend")}
                  name="backend"
                  value={data.backend || ""}
                  onChange={handleChange}
                  //opt={selOptions(codes, "uom")}
                  ro={true}
                  fullWidth
                />
              </Grid>
              <Grid item lg={12} md={12} xl={12} xs={12}>
                <TextField
                  label="Description"
                  multiline
                  rows={4}
                  name="description"
                  value={data.description || ""}
                  onChange={handleChange}
                  variant="filled"
                  fullWidth
                />

                {/* </Grid>
             <Grid item lg={12} md={12} xl={12} xs={12}>
              <img
              id="mat_img"
              alt=""
              src={data.image}
            />
            <Grid item lg={2} md={2} xl={2} xs={2}>
            <input accept="image/*" className={classes.input} id="icon-button-file" type="file" onChange={handleImgUpload} />
            <label htmlFor="icon-button-file">
              <IconButton color="primary" aria-label="Upload Picture" component="span">
                <PhotoCamera />
              </IconButton>
            </label>
            </Grid> */}
              </Grid>
              {data.cardTransactionItems &&
                data.cardTransactionItems.length > 0 && (
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <MUITableD
                      title="Line Items"
                      data={data.cardTransactionItems}
                      cols={columns}
                      sortOrder={{ name: "lineitem", direction: "asc" }}
                      onRowClick={handleRowClick}
                    />
                  </Grid>
                )}
              <Grid item lg={12} md={12} xl={12} xs={12}>
                <MUITableD
                  title="Related Transactions"
                  data={data.relatedCardTransactions}
                  cols={relColumns}
                  sortOrder={{ name: "transactionts", direction: "desc" }}
                  onRowClick={handleRelRowClick}
                />
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      <Dialog aria-labelledby="leave-popup-title" open={refundPopup.display}>
        <DialogTitle id="leave-popup-title">Issue Refund</DialogTitle>
        <DialogContent dividers>
          <Typography gutterBottom className={classes.dialogtypo}>
            Please enter a refund amount {amounttxt}
          </Typography>
          <Grid
            container
            className={clsx(classes.root, className)}
            spacing={3}
            {...rest}
          >
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <TField
                label={t("Refund Amount")}
                name="refundamount"
                value={data.refundamount != null ? data.refundamount : "0.00"}
                onChange={handleChange}
                ro={false}
                fullWidth
              />
            </Grid>
            <Grid item lg={12} md={12} xl={12} xs={12}>
              <TField
                label={t("Reason")}
                name="refunddescription"
                value={data.refunddescription || ""}
                onChange={handleChange}
                ro={false}
                fullWidth
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleLeaveRefundPopupCancel} color="primary">
            Cancel
          </Button>
          <Button
            autoFocus
            onClick={handleLeaveRefundPopupSave}
            color="primary"
            variant="outlined"
          >
            Process Refund
          </Button>
        </DialogActions>
      </Dialog>
    </Root>
  );
}

Detail.propTypes = {
  data: PropTypes.object.isRequired,
  error: PropTypes.object,
  helper: PropTypes.object,
  refundPopup: PropTypes.object,
  codes: PropTypes.array,
  handleChange: PropTypes.func,
  handleLeaveRefundPopupCancel: PropTypes.func,
  handleLeaveRefundPopupSave: PropTypes.func,
  className: PropTypes.string,
};

export default Detail;

// "data:image/jpeg;base64,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"
// style={{ maxWidth: "50px", maxHeight: "50px" }}
